import { render, staticRenderFns } from "./MedicalInformationIcon.vue?vue&type=template&id=3980e521&scoped=true&"
import script from "./MedicalInformationIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MedicalInformationIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980e521",
  null
  
)

export default component.exports